import { call, put, takeLatest, retry } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncGetDataRegisterUser({ payload }) {
  try {
    var response = yield call(API.getDataRegisterUser, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_GET_DATA_REGISTER_USER,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_GET_DATA_REGISTER_USER,
      message: error.message,
    });
  }
}

function* asyncAddDataRegisterUser({ payload }) {
  try {
    var response = yield call(API.addDataRegisterUser, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_ADD_DATA_REGISTER_USER,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_ADD_DATA_REGISTER_USER,
      message: error.message,
    });
  }
}

function* asyncDeleteDataRegisterUser({ payload }) {
  try {
    var response = yield call(API.deleteDataRegisterUser, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_DELETE_DATA_REGISTER_USER,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_DELETE_DATA_REGISTER_USER,
      message: error.message,
    });
  }
}

function* asyncRegisterUser({ payload }) {
  try {
    let response = yield call(API.registerAffiliate, payload);
    if (response) {
      yield put({ type: actionTypes.SUCCESS_REGISTER_USER, response, message: '' });
    }
  } catch (error) {
    yield put({ type: actionTypes.FAILURE_REGISTER_USER, message: error.message });
  }
}

function* asyncValidationRegister({ payload }) {
  try {
    let response = yield retry(3, 1000, API.validationRegisterUser, payload);
    if (response) {
      yield put({ type: actionTypes.SUCCESS_VERIFY_REGISTER, response });
    }
  } catch (error) {
    const message = error?.response?.data?.errors?.[0] || error?.message || "En este momento no es posible conectarse, intente más tarde."
    yield put({ type: actionTypes.FAILURE_VERIFY_REGISTER, message });
  }
}

function* asyncValidationRegisterMedico({ payload }) {
  try {
    let response = yield retry(3, 1000,API.validationMedicoRegisterUser, payload);
    if (response) {
      yield put({ type: actionTypes.SUCCESS_VERIFY_REGISTER_MEDICAL, response });
    }
  } catch (error) {
    const message = error?.response?.data?.errors?.[0] || error?.message || "En este momento no es posible conectarse, intente más tarde.";
    yield put({
      type: actionTypes.FAILURE_VERIFY_REGISTER_MEDICAL,
      message: message,
    });
  }
}

function* asyncModifyDataRegisterUser({ payload }) {
  try {
    var response = yield call(API.modifyDataRegisterUser, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_MODIFY_DATA_REGISTER_USER,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_MODIFY_DATA_REGISTER_USER,
      message: error.message,
    });
  }
}

function* asyncUserTypeValidation({ payload }) {
  try {
    let response = yield retry(3, 1000, API.validateTypeOfProfile, payload);
    if (response) {
      yield put({ type: actionTypes.SUCCESS_VALIDATE_TYPE_OF_USER, response });
    }
  } catch (error) {
    const message = error?.response?.data?.errors?.[0] || error?.message || "En este momento no es posible conectarse, intente más tarde.";
    yield put({
      type: actionTypes.FAILURE_VALIDATE_TYPE_OF_USER,
      message: message,
    });
  }
}


// Watchers
export default function* phonesSaga() {
  yield takeLatest(actionTypes.GET_DATA_REGISTER_USER, asyncGetDataRegisterUser);
  yield takeLatest(actionTypes.ADD_DATA_REGISTER_USER, asyncAddDataRegisterUser);
  yield takeLatest(actionTypes.DELETE_DATA_REGISTER_USER, asyncDeleteDataRegisterUser);
  yield takeLatest(actionTypes.MODIFY_DATA_REGISTER_USER, asyncModifyDataRegisterUser);
  yield takeLatest(actionTypes.REGISTER_USER, asyncRegisterUser);
  yield takeLatest(actionTypes.VERIFY_REGISTER, asyncValidationRegister);
  yield takeLatest(actionTypes.VERIFY_REGISTER_MEDICAL, asyncValidationRegisterMedico);
  yield takeLatest(actionTypes.VALIDATE_TYPE_OF_USER, asyncUserTypeValidation);
}
